/*****************************
 Wishlist script by @ZeroxyDev 
 Github: https://github.com/ZeroxyDev
*****************************/


const LOCAL_STORAGE_WISHLIST_KEY = 'ZDEV-wishlist';
const LOCAL_STORAGE_WISHLIST_TOTAL = 'ZDEV-wishlist-price';
const LOCAL_STORAGE_DELIMITER = ',';
const BUTTON_ACTIVE_CLASS = 'active';
const GRID_LOADED_CLASS = 'loaded';
var TIMEBETWEENEVENT = 100; // Tiempo en milisegundos
var ISTIMEOUT = false; //  Variable para controlar si hay un evento en progreso


const selectors = {
  button: '[button-wishlist]',
  grid: '[grid-wishlist]',
  productCard: '.Wishlist__Item'
};

document.addEventListener('DOMContentLoaded', () => {
  console.log('[Shopify Wishlist] Wishlist loaded ✅');
  initButtons();
  initGrid();
  waitForGrid();
  waitForButtons();
  updateIcon();
});

document.addEventListener('shopify-wishlist:updated', (event) => {
  console.log('[Shopify Wishlist] Wishlist Updated ✅', event.detail.wishlist);
  initGrid();
});

document.addEventListener('shopify-wishlist:init-product-grid', (event) => {
  console.log('[Shopify Wishlist] Wishlist Product List Loaded ✅', event.detail.wishlist);
});

document.addEventListener('shopify-wishlist:init-buttons', (event) => {
  console.log('[Shopify Wishlist] Wishlist Buttons Loaded ✅', event.detail.wishlist);
});


const waitForGrid = () => {
    const grid = document.querySelector(selectors.grid);
    if (grid) {
        console.log('[Shopify Wishlist] Grid found ✅');
        initGrid();
    } else {
        const observer = new MutationObserver((mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const addedNodes = Array.from(mutation.addedNodes);
                    const gridFound = addedNodes.some(node => node.matches && node.matches(selectors.grid));
                    if (gridFound) {
                        console.log('[Shopify Wishlist] Grid found ✅');
                        observer.disconnect();
                        initGrid();
                        break;
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
};

const waitForButtons = () => {
    let buttonLoaded = false;
    const button = document.querySelector(selectors.button);
    if (button) {
        console.log('[Shopify Wishlist] Button found ✅');
    } else {
        console.log('[Shopify Wishlist] Waiting for buttons...');
        const observer = new MutationObserver((mutationsList, observer) => {
            for (let mutation of mutationsList) {
                if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
                    const buttons = document.querySelector(selectors.button);
                    if (buttons && !buttonLoaded) {
                        console.log('[Shopify Wishlist] Button found ✅');
                        observer.disconnect();
                        initButtons();
                        buttonLoaded = true;
                        break;
                    }
                }
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
};

const updateIcon = () => {
    let cartCount = zeroxydev.helpers.Dom.nodeListToArray(document.querySelectorAll('.WishlistCountBubble')),
    wishlistQuantity = zeroxydev.helpers.Dom.nodeListToArray(document.querySelectorAll('.WishlistCountBubble__Count'));
  
    let count
    let wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;

    if (wishlist){
        count = wishlist.split(LOCAL_STORAGE_DELIMITER).length;
    } 

    cartCount.forEach(function (item) {
      count = count || 0
      if (count <= 0) {
        item.classList.remove('Visible'); 
      } else {
        item.classList.add('Visible');
      }
    });
    wishlistQuantity.forEach(function (item) {
      item.textContent = count || 0
    });
};

const fetchProductCardHTML = async (handle) => {
  const productTileTemplateUrl = `/products/${handle}?view=card`;
  return fetch(productTileTemplateUrl)
  .then((res) => res.text())
  .then((res) => {
    const text = res;
    const parser = new DOMParser();
    const htmlDocument = parser.parseFromString(text, 'text/html');
    const productCard = htmlDocument.documentElement.querySelector(selectors.productCard);
    return productCard.outerHTML;
  })
  .catch((err) => console.error(`[Shopify Wishlist] Failed to load content for handle: ${handle}`, err));
};

let eventInProgress = false; // Variable para controlar si hay un evento en progreso

const dispatchEvent = (eventName, detail) => {
  if (!eventInProgress) {
    eventInProgress = true;
    const event = new CustomEvent(eventName, { detail });
    document.dispatchEvent(event);
    setTimeout(() => {
      eventInProgress = false;
    }, 10); // Puedes ajustar el tiempo de espera según sea necesario
  }
};

const setupGrid = async(grid) => {
  const wishlist = getWishlist();
  const requests = wishlist.map(fetchProductCardHTML);
  const responses = await Promise.all(requests);
  const wishlistProductCards = responses.join('');


  const wishlistNotFoundDiv = document.querySelector('.wishlist__noitems');

  if (wishlist.length === 0) {
    wishlistNotFoundDiv.style.display = 'block';
    grid.textContent = '';
  }else{
    wishlistNotFoundDiv.style.display = 'none';
  }




  grid.innerHTML = wishlistProductCards;
  grid.classList.add(GRID_LOADED_CLASS);
  updateWishlistTotal();
  initButtons();
  updateIcon();
  dispatchEvent('shopify-wishlist:init-product-grid', { wishlist: wishlist });
};

const setupButtons = (buttons, productHandle) => {
  buttons.forEach((button) => {
    // Determinar si el producto está en la lista de deseos
    const isProductInWishlist = wishlistContains(productHandle);

    // Actualizar clase activa en el botón según esté en la lista de deseos o no
    if (isProductInWishlist) {
      button.classList.add(BUTTON_ACTIVE_CLASS);
      if (button.dataset.wishlistType === 'largeButton') {
        button.innerHTML = '<span>Added to wishlist</span>  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" class="wishlist-heart-icon" style="cursor: pointer; margin-left: 0.3rem; margin-top: -2px;"><path class="heart-path"d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"fill="var(--tg-sys-color-theme)"stroke="var(--tg-sys-color-on-surface)"stroke-width="1.2"/></svg>';
      }
    } else {
      button.classList.remove(BUTTON_ACTIVE_CLASS);
      if (button.dataset.wishlistType === 'largeButton') {
        button.innerHTML = '<span>Add to wishlist</span>  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" class="wishlist-heart-icon" style="cursor: pointer; margin-left: 0.3rem; margin-top: -2px;"><path class="heart-path"d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54z"fill="none"stroke="var(--tg-sys-color-on-surface)"stroke-width="1.2"/></svg>';
      }
    }

    button.addEventListener('click', () => {
      if (!ISTIMEOUT) {
        ISTIMEOUT = true;
        setTimeout(() => {
          ISTIMEOUT = false;
        }, TIMEBETWEENEVENT); // Puedes ajustar el tiempo de espera según sea necesario
      } else {
        return;
      }

      // Actualizar la lista de deseos al hacer clic en el botón
      updateWishlist(productHandle);
      // Actualizar la clase activa en todos los botones con el mismo handle después de cambiar la lista de deseos
      buttons.forEach((btn) => {
        if (wishlistContains(productHandle)) {
          btn.classList.add(BUTTON_ACTIVE_CLASS);
        } else {
          btn.classList.remove(BUTTON_ACTIVE_CLASS);
        }
      });
    });
  });
};
let lastInitGridCall = 0;
const initGridDelay = 500; // 1000 milisegundos = 1 segundo

const initGrid = () => {
  const currentTime = Date.now();
  if (currentTime - lastInitGridCall >= initGridDelay) {
    lastInitGridCall = currentTime;
    const grid = document.querySelector(selectors.grid) || false;
    if (grid) setupGrid(grid);
  }
};


const initButtons = () => {
  const buttons = document.querySelectorAll(selectors.button) || [];
  const groupedButtons = {};

  buttons.forEach((button) => {
    const productHandle = button.dataset.productHandle || false;
    if (!productHandle) return console.error('[Shopify Wishlist] Missing `data-product-handle` attribute. Failed to update the wishlist.');

    if (!groupedButtons[productHandle]) {
      groupedButtons[productHandle] = [];
    }
    groupedButtons[productHandle].push(button);
  });

  for (const productHandle in groupedButtons) {
    setupButtons(groupedButtons[productHandle], productHandle);
  }

  // Mostrar botóns de wishlist
  const wishlistButtons = document.querySelectorAll('.ProductCard__Wishlist');
  wishlistButtons.forEach((button) => {
    button.style.display = 'block';
  });

  dispatchEvent('shopify-wishlist:init-buttons', { wishlist: getWishlist() });
  updateIcon();
};

const getWishlist = () => {
  const wishlist = localStorage.getItem(LOCAL_STORAGE_WISHLIST_KEY) || false;
  if (wishlist) return wishlist.split(LOCAL_STORAGE_DELIMITER);
  return [];
};

const setWishlist = (array) => {
  const wishlist = array.join(LOCAL_STORAGE_DELIMITER);
  if (array.length) localStorage.setItem(LOCAL_STORAGE_WISHLIST_KEY, wishlist);
  else localStorage.removeItem(LOCAL_STORAGE_WISHLIST_KEY);

  dispatchEvent('shopify-wishlist:updated', { wishlist: array });
  updateIcon();
  return wishlist;
};

const updateWishlistTotal = () => {
    const wishlist = getWishlist();
    let totalPrice = 0;
    wishlist.forEach((handle) => {
      const button = document.querySelector(`[data-product-handle="${handle}"]`);
      if (button) {
        const productPrice = parseFloat(button.dataset.productPrice) || 0;
        totalPrice += productPrice;
      }
    });

    localStorage.setItem(LOCAL_STORAGE_WISHLIST_TOTAL, totalPrice.toFixed(2));

    const formattedPrice = new Intl.NumberFormat(`${window.Shopify.locale}`, { style: 'currency', currency: `${window.Shopify.currency.active}` }).format(totalPrice / 100);
    const wishlistTotal = document.querySelector('.wishlist__total-count');
    if (!wishlistTotal)return
    wishlistTotal.textContent = formattedPrice;
  };

  const updateWishlist = (handle) => {
    const wishlist = getWishlist();
    const indexInWishlist = wishlist.indexOf(handle);
    const isNewProduct = indexInWishlist === -1;
  
    if (isNewProduct) {
      wishlist.push(handle);
    } else {
      wishlist.splice(indexInWishlist, 1);
    }
  
    setWishlist(wishlist);
    updateWishlistTotal();
  };

const wishlistContains = (handle) => {
  const wishlist = getWishlist();
  return wishlist.includes(handle);
};

const resetWishlist = () => {
  return setWishlist([]);
};
